import { useChartLayoutLoading } from '../../../core/components/chart-layout/hooks/useChartLayoutLoading.js';
import { useChartLayoutOrientation } from '../../../core/components/chart-layout/hooks/useChartLayoutOrientation.js';
import { getLegendOrientation } from '../../../core/components/chart-layout/utils/orientation.js';
import { ChartLegend } from '../../../core/components/legend/categorical/ChartLegend.js';
import { useLegendSeriesActions } from '../../../core/components/legend/categorical/hooks/useLegendSeriesActions.js';
import { LegendItem } from '../../../core/components/legend/categorical/types/legend.js';
import { useTooltip as useTooltipStore } from '../../../core/components/overlay-tooltip/contexts/TooltipContext.js';
import { NAME_ACCESSOR } from '../../constants.js';
import { useNameAccessor } from '../../context/NameAccessorContext.js';
import { useTreeMapHandlers } from '../../hooks/useTreeMapChartHandlers.js';
import { useTruncationMode } from '../../hooks/useTruncationMode.js';
import { useColorMap } from '../../store/selectors.js';
import type { TreeMapCategoricalLegendItem } from '../../types/internal.js';
import { getLegendInteractionProps } from '../../utils/get-legend-interaction-props.js';
import { getLegendItems } from '../../utils/get-legend-items.js';

export const TreeMapCategoricalLegend = () => {
  const legendColorMap = useColorMap();
  const nameAccessor = useNameAccessor();
  const { onLegendItemHover, onLegendItemClick } = useTreeMapHandlers();
  const tooltipStore = useTooltipStore();

  const { orientation: layoutOrientation } = useChartLayoutOrientation();
  const legendOrientation = getLegendOrientation(layoutOrientation);
  const truncationMode = useTruncationMode();
  const isTooltipPinned = tooltipStore.getState?.().pinned ?? false;
  const isLoading = useChartLayoutLoading();

  const legendItems = getLegendItems(
    legendColorMap,
  ) as TreeMapCategoricalLegendItem[];

  const legendActions = useLegendSeriesActions<LegendItem>(
    legendItems ?? [],
    (item) => item.id,
  );

  const hasValueNameAccessor = nameAccessor === NAME_ACCESSOR.Value;
  const chartLegendInteractionsProps = getLegendInteractionProps(
    isTooltipPinned,
    isLoading,
    hasValueNameAccessor,
    legendActions,
    onLegendItemHover,
    onLegendItemClick,
  );

  return (
    <ChartLegend
      items={legendItems ?? []}
      truncationMode={truncationMode}
      orientation={legendOrientation}
      {...chartLegendInteractionsProps}
    />
  );
};
